import styled from "styled-components";
const Main = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  postion: relative;
`;
export { Main };
